import React from 'react';
import { connect } from 'react-redux';
import PageSectionWithWave from '../PageSectionWithWave';

/**
 * A tiny container component that knows about browser properties
 * so it can responsively draw diferent svg waveforms.
 * Re-used in many static pages
 */
const mapStateToProps = state => ({
  drawWavePoints: getDrawWavePointstFromBrowser(state.browser),
});

export default connect(mapStateToProps)(PageSectionWithWave);

function getDrawWavePointstFromBrowser(browser) {
  /*
const pointsStrSm = `
M 0 0
L 100 0
L 100 90
Q 116,94 100,90
T 66,90
T 33,90
T 0,90
Z
`;
  */

  const pointsStrMd = `
M 0 0
L 1.00 0
L 1.00 0.90

Q 1.10,0.95 1.00,0.90
T 0.80,0.90
T 0.60,0.90
T 0.40,0.90
T 0.20,0.90
T 0,0.90

Z
`;

  const pointsStrLg = `
M 0 0
L 1.00 0
L 1.00 0.90

Q 1.05,0.95 1.00,0.90
T 0.90,0.90
T 0.80,0.90
T 0.70,0.90
T 0.60,0.90
T 0.50,0.90
T 0.40,0.90
T 0.30,0.90
T 0.20,0.90
T 0.10,0.90
T 0,0.90

Z
`;

  const pointsStrSm = pointsStrMd;

  const { mediaType } = browser;
  return {
    extraSmall: pointsStrSm,
    small: pointsStrSm,
    medium: pointsStrMd,
    large: pointsStrLg,
    extraLarge: pointsStrLg,
    infinity: pointsStrLg,
  }[mediaType];
}
